import { render, staticRenderFns } from "./ArrivalTimerView.vue?vue&type=template&id=8323f3ec&scoped=true&"
import script from "./ArrivalTimerView.vue?vue&type=script&lang=ts&"
export * from "./ArrivalTimerView.vue?vue&type=script&lang=ts&"
import style0 from "./ArrivalTimerView.vue?vue&type=style&index=0&id=8323f3ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8323f3ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/rensvannijnatten/source/repos/AZNConnect/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon,VTooltip})
